import { Navigate } from 'react-router-dom'

import AuthService from '../../utilities/services/auth.service'
import { OrganizationSettingsWrapper } from '../../components'

export default function OrganizationSettingsPage() {
  if (!AuthService.isSuperAdminOrganizer()) {
    return <Navigate to="/settings/organization-information" replace />
  }

  return <OrganizationSettingsWrapper />
}
